import differenceInSeconds from "date-fns/differenceInSeconds";

export const getGetSecondsUntilNextloginAttempt = (
  challengeParams?: Record<string, string>
): number => {
  const nextLoginAttemptAt = challengeParams?.nextLoginAttemptAt;

  if (!nextLoginAttemptAt) {
    return 0;
  }

  const nextLoginAttemptDate = new Date(nextLoginAttemptAt);

  return differenceInSeconds(nextLoginAttemptDate, new Date());
};
